module.exports = __webpack_public_path__ + "img/c202ac9.png";